import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button as MUIButton,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import { CreditCard, AccountBalance } from "@mui/icons-material";
import SavingsIcon from "@mui/icons-material/Savings";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { useNavigate } from "react-router-dom";
import { createNach } from "../../../../pay-later/services/sanctions";

let Digio;

interface ApplicationProps {
  applicationId: string;
  userId: string;
  mobile: string;
}

interface DigioMandateModalProps {
  application: ApplicationProps;
  open: boolean;
  onClose: () => void;
}

const DigioMandateModal = ({
  application,
  open,
  onClose,
}: DigioMandateModalProps) => {
  const [radioSelectedAccount, setRadioSelectedAccount] = useState("SAVINGS");
  const [radioSelectedMandate, setRadioSelectedMandate] =
    useState("NET_BANKING");
  const [state, setState] = useState({ accountNumber: "", ifscCode: "" });
  const [authToken, setAuthToken] = useState({ mob: "", value: "" });

  const navigate = useNavigate();

  const handleChange = (key: string, val: string) =>
    setState((prev) => ({ ...prev, [key]: val }));

  useEffect(() => {
    if (
      application?.mobile &&
      application?.userId &&
      application?.applicationId
    ) {
      fetch(
        `${process.env.REACT_APP_DASHBOARD_URL}/integrations-login/generate-token`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            mobile: application.mobile,
            userId: application.userId,
            applicationId: application.applicationId,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => {
          setAuthToken({
            mob: application.mobile,
            value: data.data,
          });
        })
        .catch((error) => {
          console.error("Error generating token:", error);
        });
    }
  }, [application]);

  // const fetchJsFromCDN = (src: string, externals: string[]) => {
  //   return new Promise<any>((resolve, reject) => {
  //     const script = document.createElement("script");
  //     script.src = src;
  //     script.onload = () =>
  //       resolve(externals.map((key) => (window as any)[key]));
  //     script.onerror = reject;
  //     document.body.appendChild(script);
  //   });
  // };

  const fetchJsFromCDN = (src : any, externals: string[]) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.setAttribute("src", src);
      script.addEventListener("load", () => {
        resolve(
          externals.map((key: any) => {
            const ext = window[key];
            if (typeof ext === "undefined") {
              console.warn(`No external named '${key}' in window`);
            }
            return ext;
          })
        );
      });
      script.addEventListener("error", reject);
      document.body.appendChild(script);
    });
  };

  const getRazorpayUrl = async () => {
    const { accountNumber, ifscCode } = state;
    if (!accountNumber || !ifscCode) {
      // alert("All fields are required");
      return {message:"Enter all the fieldsssss"}
    }

    const payload = {
      accountNumber,
      accountType: radioSelectedAccount,
      ifscCode,
      mandateType: radioSelectedMandate,
      userId: application.userId,
      applicationId: application.applicationId,
      mobile: application.mobile,
    };

    return await createNach(payload);
  };

  const initiateDigio = async () => {
    await fetchJsFromCDN("https://app.digio.in/sdk/v11/digio.js", [
      "Digio",
    ]).then(async (digio:any) => {
      Digio = digio[0];
      const digioInstance = new Digio({
        environment: "production",
        callback: (response: any) => {
          if (response?.error_code) {
            alert(response.message);
            window.location.reload();
            return;
          }
          window.location.reload();
          navigate("/mainpage");
        },
        theme: { primaryColor: "#AB3498", secondaryColor: "#000" },
        is_iframe: true,
        dg_preferred_auth_type: radioSelectedMandate,
      });

      const response = await getRazorpayUrl();

      if (response?.mandate_id) {
        digioInstance.init();
        digioInstance.submit(
          response.mandate_id,
          authToken.mob,
          response.access_token.id
        );
      } else {
        alert(response?.message || "Something went wrong");
      }
    });
  };

  const handleSubmit = () => {
    onClose();
    setTimeout(initiateDigio, 300);
  };
  
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        // sx={{ bgcolor: "#e03a42", color: "#ffffff", fontWeight: 600 }}
      >
        Setup e-Mandate
      </DialogTitle>

      <DialogContent dividers sx={{ bgcolor: "#fff8f4" }}>
        <Typography
          variant="subtitle1"
          gutterBottom
          sx={{ fontWeight: 800, ml: 6 }}
        >
          Bank Account Details
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            flexWrap: "wrap",
            // marginTop: 2,
            marginLeft: 8,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle2">Account Number</Typography>
            <TextField
              // fullWidth
              sx={{ width: "80%" }}
              value={state.accountNumber}
              onChange={(e) => handleChange("accountNumber", e.target.value)}
              variant="outlined"
              margin="dense"
            />
          </Box>

          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle2">IFSC Code</Typography>
            <TextField
              // fullWidth
              sx={{ width: "80%" }}
              value={state.ifscCode}
              onChange={(e) => handleChange("ifscCode", e.target.value)}
              variant="outlined"
              margin="dense"
            />
          </Box>
        </Box>

        {/* <Box >
          <Divider />
        </Box> */}

        <FormControl margin="normal" fullWidth>
          <FormLabel sx = {{fontWeight: 800,}} >Account Type</FormLabel>
          <RadioGroup
            row
            value={radioSelectedAccount}
            onChange={(e) => setRadioSelectedAccount(e.target.value)}
            sx={{ ml: 8 }}
          >
            <FormControlLabel
              value="SAVINGS"
              control={<Radio />}
              label={
                <Box display="flex" alignItems="center" gap={1}>
                  <SavingsIcon fontSize="small" />
                  <Typography variant="body1">Savings</Typography>
                </Box>
              }
            />
            <FormControlLabel
              value="CURRENT"
              control={<Radio />}
              label={
                <Box display="flex" alignItems="center" gap={1}>
                  <AccountBalanceIcon fontSize="small" />
                  <Typography variant="body1">Current</Typography>
                </Box>
              }
            />
          </RadioGroup>
        </FormControl>

        <FormControl margin="normal" fullWidth>
          <FormLabel sx = {{fontWeight: 800,}}>How do you want to authenticate your account?</FormLabel>
          <RadioGroup
            row
            value={radioSelectedMandate}
            onChange={(e) => setRadioSelectedMandate(e.target.value)}
            sx={{ ml: 8 }}
          >
            <FormControlLabel
              value="NET_BANKING"
              control={<Radio />}
              label={
                <Box display="flex" alignItems="center">
                  <AccountBalance fontSize="small" sx={{ mr: 1 }} />
                  Net Banking
                </Box>
              }
            />
            <FormControlLabel
              value="DEBIT_CARD"
              control={<Radio />}
              label={
                <Box display="flex" alignItems="center">
                  <CreditCard fontSize="small" sx={{ mr: 1 }} />
                  Debit Card
                </Box>
              }
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <MUIButton onClick={onClose} variant="outlined" color="secondary">
          Cancel
        </MUIButton>
        <MUIButton onClick={handleSubmit} variant="contained" color="primary">
          Continue
        </MUIButton>
      </DialogActions>
    </Dialog>
  );
};

export default DigioMandateModal;
